import { Container, LinearProgress } from "@mui/material";
import styled from "styled-components";

import { FileEntry, selectAllFileEntries, useAppSelector } from "model";
import RelevantFileEntryList from "./RelevantFileEntryList";

export default function RelevantFilesList() {
  const fileEntriesLoading = useAppSelector(
    (state) => state.fileEntries.loading
  );
  const user = useAppSelector((state) => state.user.details);
  const allFileEntries: Array<FileEntry> = useAppSelector((state) =>
    selectAllFileEntries(state)
  );

  const allRelevantFileEntries = allFileEntries.filter(
    (fileEntry) => fileEntry.associatedUserId === user?.guid
  );

  const sortedFileEntries = allRelevantFileEntries.sort(
    (a: FileEntry, b: FileEntry) =>
      new Date(b.creationDate ?? "").valueOf() -
      new Date(a.creationDate ?? "").valueOf()
  );

  if (fileEntriesLoading !== "idle") {
    return <LinearProgress />;
  }

  return (
    <>
      <FileEntryListContainer maxWidth="sm">
        <RelevantFileEntryList fileEntries={sortedFileEntries} />
      </FileEntryListContainer>
    </>
  );
}

const FileEntryListContainer = styled(Container)``;
